import { Icon } from '@toggle/design-system';
import React, { CSSProperties } from 'react';

import styles from './TopRankIcon.module.scss';

interface TopRankIconProps {
  rank?: number;
  iconSize?: number;
  wrapperSize?: number;
  limit?: number;
  rankFontSize?: number;
  rankTopPosition?: string;
}

export const TopRankIcon = ({
  rank,
  iconSize = 32,
  wrapperSize = 32,
  limit = 3,
  rankFontSize = 14,
  rankTopPosition = '14%',
}: TopRankIconProps) => {
  if (!rank) {
    return <div className={styles.styledPlaceholder}>-</div>;
  }

  if (rank <= limit) {
    return (
      <div
        className={styles.wrapper}
        style={{ '--wrapper-size': `${wrapperSize}px` } as CSSProperties}
      >
        <div
          className={styles.styledIconRank}
          style={
            {
              '--font-size': `${rankFontSize}px`,
              '--top-position': rankTopPosition,
            } as CSSProperties
          }
          data-testid="rank-icon"
        >
          {rank}
        </div>
        <Icon
          size={iconSize}
          iconName="Rank"
          fillColor={'var(--icon-default)'}
        />
      </div>
    );
  }

  return <div className={styles.styledRank}>{rank}</div>;
};
